import env from '@beam-australia/react-env';

const AUTH_COOKIE_NAME = 'ab_wordpress_access';
const AUTH_COOKIE_VALUE = 'permit';

const AUTH_COOKIE = `${AUTH_COOKIE_NAME}=${AUTH_COOKIE_VALUE};domain=${env('AUTH_COOKIE_DOMAIN')}`;

export function setCookie() {
  document.cookie = AUTH_COOKIE;
}

export function clearCookie() {
  const now = (new Date()).toUTCString();

  document.cookie = `${AUTH_COOKIE};expires=${now}`;
}
